import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const test: ContentBlock<"test"> = {
  id: makeId("test-saline-sonogram"),
  kind: "test",
  tags: ["clinic-visit", "her", "testing", "pre-cycle"],
  title: "Saline Sonogram (SIS)",
  subtitle: "Saline infusion ultrasound to evaluate the uterine cavity",
  body: {
    testName: "Saline Infusion Sonohysterogram (SIS)",
    category: "imaging",
    whatItMeasures:
      "Evaluates the inside of the uterine cavity using sterile saline and transvaginal ultrasound. It can detect polyps, fibroids, scar tissue, and other structural abnormalities that may interfere with implantation.",
    howItWorks:
      "You lie on an exam table and a speculum is placed, similar to a Pap smear. A thin, flexible catheter is threaded through the cervix and a small amount of sterile saline is slowly infused into the uterine cavity. The saline expands the cavity, allowing the physician to see its contours clearly on transvaginal ultrasound. The entire procedure takes about 10-15 minutes. The saline is naturally absorbed and expelled by the body. If any abnormalities are found — such as a polyp or submucosal fibroid — your doctor may recommend a hysteroscopy to remove it before proceeding with treatment. Schedule between cycle days 6-12 (after your period, before ovulation). Take 400-600mg ibuprofen 30-60 minutes before the procedure to reduce cramping. You may experience brief discomfort when the catheter is placed and a sensation of pressure or mild cramping as saline fills the uterus. Results are discussed immediately after the procedure.",
    quickFacts: [
      { kind: "sample", value: "Saline ultrasound" },
      { kind: "time", value: "10-15 min procedure" },
      { kind: "pain", value: "Brief cramping or pressure" },
      { kind: "anesthesia", value: "Usually none" },
      { kind: "prep", value: "Cycle days 6-12; ibuprofen if allowed" },
      { kind: "results", value: "During the appointment" },
    ],
    costRange: { low: 200, high: 600 },
    atHome: false,
    clinicRequired: true,
    cycleDay: "Follicular phase (cycle days 6-12)",
    dataPoints: [],
    section: "implantation",
  },
  sources: [
    {
      title:
        "Diagnostic accuracy of saline infusion sonography in the evaluation of uterine cavity abnormalities prior to assisted reproductive techniques: a systematic review and meta-analyses",
      authors: "Seshadri S, El-Toukhy T, Douiri A, Jayaprakasan K, Khalaf Y",
      journal: "Human Reproduction Update",
      year: 2015,
      url: "https://pubmed.ncbi.nlm.nih.gov/25505226/",
      evidenceLevel: "meta-analysis",
    },
  ],
  readTimeMinutes: 3,
};

registerBlock(test);
